// Helper function to cast a node containing a fragment to the type-safe fragment.
// This is a workaround since the generated Relay files need to live in the same folder for Relay to be aware of nested fragment definitions.
// This is not possible as long as we have mixed JS and TSX sources.
export function asFragment(node) {
    return node;
}
